import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { Text } from '@fiverr-private/typography';
import { Container } from '@fiverr-private/layout_components';
import { getContext } from '@fiverr-private/fiverr_context';
import { LockedIcon } from '@fiverr-private/visuals';
import { CollectionMenuOption } from '../../types';

interface CollectionLabelProps {
    collection: CollectionMenuOption;
    maxWidth?: `${number}px`;
}

export const CollectionLabel = ({ collection, maxWidth }: CollectionLabelProps) => {
    const {
        experience: { isBusiness },
    } = getContext();

    return (
        <>
            <Text overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" maxWidth={maxWidth}>
                {collection.name}
            </Text>
            {isBusiness && collection.isPrivate && (
                <Container
                    as="span"
                    display="inlineFlex"
                    height="fit-content"
                    marginLeft="2"
                    color="grey_900"
                    aria-label={translate<string>('collect_actions.lists_popover.private')}
                >
                    <LockedIcon />
                </Container>
            )}
        </>
    );
};
